/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _typeof from '@babel/runtime/helpers/typeof';

function isPlainObject(item) {
  return item !== null && _typeof(item) === 'object' && item.constructor === Object;
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  var output = {};
  Object.keys(source).forEach(function (key) {
    output[key] = deepClone(source[key]);
  });
  return output;
}

/**
 * Merges two objects together.
 * Modified from the original function in Material-UI (MUI) library.
 * @see https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/deepmerge.ts
 * @param {object} target - Target object (base)
 * @param {object} source - Source object (overrides)
 */
function deepMerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var clone = options.clone;
  var output = clone ? _objectSpread({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepMerge(target[key], source[key]);
      } else if (clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

export { deepMerge as default };
